<template>
    <div>
        <div style="width: 220px;">
            <div class="search-container primary mb15 mt10">
                <div class="form-box">
                    <input class="input-field" v-model="title" placeholder="请输入招标书名称"/>
                    <button class="search-btn" @click="getBidDocList()"><i class="icon iconfont icon-search"></i></button>
                </div>
            </div>
        </div>
        <hr/>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="bidDocList" border tooltip-effect="dark" style="width: 100%" @select="handleSelectionChange">
                <el-table-column align="center" type="selection" width="55"></el-table-column>
                <el-table-column align="center" prop="title" label="招标标题"></el-table-column>
                <el-table-column align="left" prop="fstPartyName" label="招标方"></el-table-column>
                <el-table-column align="left" width="150" prop="callContactName" label="联系人"></el-table-column>
                <el-table-column align="left" width="120" prop="callContactTel" label="联系电话"></el-table-column>
                <el-table-column align="left" width="200" prop="callContactEmail" label="联系邮箱"></el-table-column>
                <el-table-column align="center" width="180" prop="resultPublishTime" label="结果公布时间"></el-table-column>
            </el-table>
        </div>

        <div class="block pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import tendBidApi from '../../api/tendBid'

    export default {
        name: 'swb-bid-doc-for-select',
        desc: '投标书-选择(合同使用)',
        props: ['rowId', 'isMultiple', 'empty', 'type'],
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                bidDocList: [],
                title: null,
                multipleSelection: null,

                winTheBidState: {}
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.winTheBidState = getEnumInfoWith("bidDocState", 'name', 'WinTheBid');

            this.getBidDocList();
            this.selectTable();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getBidDocList();
            },
            getBidDocList: function () {
                let self = this;

                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                if(!Utils.isNoB(self.title)) {
                    filterItems.title = self.title;
                }
                filterItems.bidState = self.winTheBidState.value;
                if(self.type == 'goods') {
                    filterItems.goodsFlag = true;
                    filterItems.servcFlag = false;
                } else if(self.type == 'goodsAndServc') {
                    filterItems.goodsFlag = true;
                    filterItems.servcFlag = true;
                } else {
                    filterItems.servcFlag = true;
                    filterItems.goodsFlag = false;
                }
                filterItems.forAll = true;
                postData.filterItems = filterItems;
                //
                let theLoad = MsgBox.loading();
                tendBidApi.getBidDocList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.bidDocList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleSelectionChange(selection, row) {
                if(this.isMultiple) {
                    this.multipleSelection = selection;
                } else if(this.empty) {
                    if(this.multipleSelection != null && this.multipleSelection.id == row.id) {
                        this.$refs.multipleTable.clearSelection();
                        this.multipleSelection = null;
                        return;
                    }
                    this.multipleSelection = row;
                } else {
                    this.$refs.multipleTable.clearSelection(selection);
                    this.$refs.multipleTable.toggleRowSelection(row);
                    this.multipleSelection = row;
                }
            },
            selectTable: function () {
                if(this.rowId != null) {
                    setTimeout(() => {
                        let bidDocList = this.bidDocList;
                        for(var i = 0; i < bidDocList.length; i++) {
                            if(bidDocList[i].id == this.rowId) {
                                this.$refs.multipleTable.toggleRowSelection(bidDocList[i]);
                                this.multipleSelection = bidDocList[i];
                                break;
                            }
                        }
                    }, 10);
                }
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let multipleSelection = self.multipleSelection;
                if(multipleSelection != null) {
                    result.type = 'info';
                    result.data = multipleSelection;
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/BidDocForSelect.vue